var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('Header'),_c('div',{staticClass:"page-body wrap"},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }